<script module lang="ts">
  import type { CampaignCardProps } from '../../../components';
  import type { CampaignCardStoryblok } from '~/component-types-sb';

  export interface CampaignCardStoryblokProps {
    blok: CampaignCardStoryblok;
  }
</script>

<script lang="ts">
  import { storyblokEditable } from "@storyblok/svelte";
  import { CampaignCard } from '../../../components';
  import { storyLinkToLink } from '../../../utils/transformer.client';

  const { blok }: CampaignCardStoryblokProps = $props();

  const campaignCardProps: CampaignCardProps = {
    image: blok?.image?.filename ?? '',
    use: [[storyblokEditable, blok]],
    title: blok.title ?? '',
    badgeLabel: blok.badge_label ?? '',
    description: blok.description ?? '',
    buttonLabel: blok.button_label,
    discountLabel: blok.discount_label,
    size: blok.size || 'md',
    href: storyLinkToLink(blok.path ?? ''),
    customProps: { ...blok }
  };
</script>

<CampaignCard {...campaignCardProps} />
